<script setup lang="ts">
import ServiceSettingAddStep1 from "@/views/playground/planner/order-management/service-setting/add/ServiceSettingAddStep1.vue";
</script>

<template>
  <service-setting-add-step1></service-setting-add-step1>
</template>

<style scoped></style>
